import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { AutocallBarrierLevelFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallBarrierLevelFormField'
import { AutocallBarrierStepFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallBarrierStepFormField'
import { AutocallYearlyObservationsFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallYearlyObservationsFormField'
import { CouponRateAnnualFormField } from '@/pages/instruments/new-instrument/form-fields/CouponRateAnnualFormField'
import { CouponYearlyObservationsFormField } from '@/pages/instruments/new-instrument/form-fields/CouponYearlyObservationsFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'
import { PayoffBarrierLevelFormField } from '@/pages/instruments/new-instrument/form-fields/PayoffBarrierLevelFormField'
import { PayoffBarrierStepFormField } from '@/pages/instruments/new-instrument/form-fields/PayoffBarrierStepFormField'
import { PhoenixNonMemorySchemaType } from '@/pages/instruments/new-instrument/schemas/phoenix-non-memory.schema'

export interface PhoenixNonMemoryFormFieldsProps {}

export const PhoenixNonMemoryFormFields: React.FC<PhoenixNonMemoryFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<PhoenixNonMemorySchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <AutocallYearlyObservationsFormField />
          <CouponYearlyObservationsFormField />
          <CouponRateAnnualFormField />
          <AutocallBarrierLevelFormField />
        </FormFieldRow>
        <FormFieldRow>
          <PayoffBarrierLevelFormField />
          <PayoffBarrierStepFormField />
          <AutocallBarrierStepFormField />
          <KnockDownInputLevelFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
